import { states } from "@/components/molecules/mixins/form.mixin";

import fideliteApiDrive from "@/services/http/api-drive/client/fidelite";
import { useClientStore } from "@/store/client";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import { useAxiosHelper } from "@/utils/axios-helper";

export const useCreationCarteFidelite = () => {
  const error = ref(null);
  const state = ref(null);
  const isErrorCarteAssociee = ref(false);
  const clientStore = useClientStore();
  const app = useNuxtApp();
  const { getErrorStatus } = useAxiosHelper();

  const { trackEvent } = useInteractionDoneTracking();

  const { isEligibleDefis } = storeToRefs(clientStore);

  const { update, setClientCarteMalin } = clientStore;

  const isLoading = computed(() => {
    return state.value === states.LOADING
  });

  const addCarte = async (data) => {
    state.value = states.LOADING;
    try {
      await update(data);
      navigateToInternal("/mon-compte/ma-fidelite?nouvelleCarte=1");
    } catch (err) {
      error.value = err;      
      isErrorCarteAssociee.value = getErrorStatus(err) === 409;      
    } finally {
      state.value = states.DEFAULT;
    }
  }

  const createCarte = async (data) => {
    state.value = states.LOADING;
    try {
      const infosCarte = await app.$apiDrive.use(fideliteApiDrive).create(data);
      setClientCarteMalin(infosCarte.data.id);
      trackEvent({
        event: trackingCodes.EVENTS.signUp,
        pageType: trackingCodes.PAGETYPE.creationCarteFidelite,
        categoryGA: trackingCodes.CATEGORYGA.subscriptionOK,
        actionGA: trackingCodes.ACTIONGA.formulaireCreationCarteMalin,
        email: data.acceptEmail,
        sms: data.acceptSms,
        carteFidelite: "malin"
      });
      navigateToInternal("/mon-compte/ma-fidelite?nouvelleCarte=1");
    } catch (error) {
      trackEvent({
        event: trackingCodes.EVENTS.affichageErreur,
        pageType: trackingCodes.PAGETYPE.creationCarteFidelite,
        categoryGA: trackingCodes.CATEGORYGA.popinErreur,
        actionGA: trackingCodes.EVENTS.affichageErreur,
        labelGA: error.response ? error.response.status : "error"
      });
      navigateToInternal(
        `/erreur-creation-carte?${error.response && error.response.status === 409 ? "carteExistante=1" : ""
        }`
      );
    } finally {
      state.value = states.DEFAULT;
    }
  }

  return {
    error,
    state,
    isEligibleDefis,
    update,
    setClientCarteMalin,
    isLoading,
    addCarte,
    createCarte,
    isErrorCarteAssociee
  }
}
